import { render, staticRenderFns } from "./DashboardTest.vue?vue&type=template&id=00ce0d38&"
import script from "./DashboardTest.vue?vue&type=script&lang=js&"
export * from "./DashboardTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports